module.exports = __webpack_public_path__ + "static/media/chevron-down.3d9110d3.svg";